<template>
    <el-dialog
        :title="$t('yingji.emergencyCase.createCase')"
        :visible.sync="dialogVisible"
        width="400px"
        :close-on-click-modal="false"
        :close-on-press-escape="true"
        :show-close="true"
        :modal="true"
        :z-index="3000"
        :append-to-body="true"
        custom-class="yingji-dialog"
        @close="handleCancelAddCase">
        <el-form :model="addCaseForm">
            <div class="case-input-wrapper">
                <el-input v-model="addCaseForm.name" :placeholder="$t('yingji.emergencyCase.pleaseInputCaseName')" clearable></el-input>
            </div>
        </el-form>
        <div slot="footer" class="case-dialog-footer">
            <el-button class="case-btn-cancel" @click="handleCancelAddCase">{{ $t('yingji.emergencyCase.cancel') }}</el-button>
            <el-button class="case-btn-confirm" type="primary" @click="handleConfirmAddCase">{{ $t('yingji.emergencyCase.confirm') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import IndexApi from '@/page/business/yingji/api/index.js';

export default {
    name: 'AddCaseDialog',
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        pendingAddCaseParams: {
            type: Object,
            default: null,
        },
    },
    data () {
        return {
            addCaseForm: {
                name: '',
                location: '',
            },
            isConfirming: false,
        };
    },
    computed: {
        dialogVisible: {
            get () {
                return this.visible;
            },
            set (val) {
                this.$emit('update:visible', val);
            },
        },
    },
    methods: {
        handleCancelAddCase () {
            if (this.isConfirming) return;
            this.addCaseForm = { name: '', location: '' };
            this.$emit('cancel');
        },

        async handleConfirmAddCase () {
            if (!this.addCaseForm.name.trim()) {
                this.$message.warning('请输入案件名称');
                return;
            }
            if (!this.pendingAddCaseParams) {
                this.$message.error('参数错误，请重新点击地图添加');
                this.$emit('cancel');
                return;
            }

            const params = {
                ...this.pendingAddCaseParams,
                name: this.addCaseForm.name.trim(),
                location: this.addCaseForm.location.trim(),
            };
            this.isConfirming = true;
            await this.handleAddCase(params);
            this.$emit('confirm', params);
            this.isConfirming = false;
        },

        async handleAddCase (params) {
            await IndexApi.addCase({ ...params });
        },
    },
};
</script>

<style lang="scss">
.el-dialog__wrapper .yingji-dialog {
    background: #071150 !important;
    border: 1px solid #49f0fd !important;
    box-shadow: inset 0px 0px 10px 0px #49f0fd !important;
    border-radius: 6px !important;
    margin: auto !important;
    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;

    .el-dialog__header {
        padding: 18px 0 18px 24px;
        border-bottom: 1px solid #49f0fd !important;
        box-shadow: inset 0px 0px 10px 0px #49f0fd !important;
        background: transparent !important;

        .el-dialog__title {
            height: 21px;
            font-size: 16px;
            font-weight: 400;
            color: #49f0fd !important;
            line-height: 19px;
        }

        .el-dialog__close {
            color: #49f0fd !important;

            &:hover {
                color: #fff !important;
            }
        }
    }

    .el-dialog__body {
        background: transparent !important;
        padding: 20px 24px;

        .el-input__inner {
            background-color: #071150 !important;
            border: 1px solid rgba(135, 161, 216, 0.7) !important;
            color: #49f0fd !important;
            font-size: 14px;

            &::placeholder {
                color: rgba(73, 240, 253, 0.5) !important;
            }
        }
    }

    .el-dialog__footer {
        background: transparent !important;
        padding: 10px 24px 20px;
        border-top: none !important;
    }
}

.case-input-wrapper {
    padding: 10px 0;
}

.case-dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 15px;
}

.case-btn-cancel {
    flex: 0 0 80px;
    height: 30px;
    line-height: 12px;
    font-size: 16px;
    background: rgba(255, 255, 255, 0.15) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    color: #fff !important;
    border-radius: 4px;

    &:hover {
        background: rgba(255, 255, 255, 0.25) !important;
        border-color: rgba(255, 255, 255, 0.5) !important;
    }
}

.case-btn-confirm {
    flex: 0 0 80px;
    height: 30px;
    line-height: 12px;
    font-size: 16px;
    background: rgba(73, 240, 253, 0.25) !important;
    border: 1px solid #49f0fd !important;
    color: #49f0fd !important;
    border-radius: 4px;

    &:hover {
        background: rgba(73, 240, 253, 0.4) !important;
    }
}
</style>
